<template>

    <list-container :name="name">

        <list-nav>
            <list-nav-header title="Sales Orders" searchable="true"></list-nav-header>


            <list-nav-scroll>
                <table class="responsive-table fix-head">
                    <thead>
                    <tr>
                        <th scope="col">Reference</th>
                        <th scope="col">Status</th>
                        <th scope="col">Raised</th>
                        <th scope="col">Delivery Date</th>
                        <th scope="col">Package</th>
                        <th scope="col">Client</th>
                        <th scope="col">Client Reference</th>
                        <th scope="col">Cost (ex VAT)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td scope="row" data-label="Reference">{{ item.reference }}</td>
                        <td data-label="Status">{{ item.status }}</td>
                        <td data-label="Raised">{{ item.raised }}</td>
                        <td data-label="Delivery Date">{{ item.delivery_date }}</td>
                        <td data-label="Package" v-if="item.package"><a :href="item.package.data._links.frontend.view">{{ item.package.data.name }}</a></td>
                        <td data-label="Package" v-else>No Package</td>
                        <td data-label="Client">{{ item.client }}</td>
                        <td data-label="Client Reference">{{ item.client_reference }}</td>
                        <td data-label="Cost (ex VAT)">&pound;{{ item.costs.net }}</td>
                    </tr>
                    </tbody>
                </table>
                <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                    <span slot="no-more">
                      End Of Sales Orders
                    </span>
                </infinite-loading>
            </list-nav-scroll>
        </list-nav>

    </list-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            InfiniteLoading,
        },
        props:['compact','packageId','clientType','clientId'],
        data() {
            return {
                name: 'salesorders',
                items: [],
                nextPaginationUrl: '',
                search_query: null,
            }
        },
        filters: {

        },
        watch: {
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            },
            clientId: function(){
                this.getItems();
            },
            clientType: function(){
                this.getItems();
            }
        },
        computed: {
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            }
        },
        methods: {
            getItems() {
                this.items = [];
                var that = this;
                var url = appUrls.salesorders.index;
                var params = {};

                if (this.has_query) {
                    params.query = this.search_query;
                }

                if (this.packageId) {
                    params.package_id = this.packageId;
                }

                if(this.clientId)
                {
                    params.client_id = this.clientId;
                    params.client_type = this.clientType;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.nextPaginationUrl = response.data['meta']['pagination']['_links']['next'];
                    });
            },
            loadMoreItems: _.debounce(function ($state) {
                var that = this;

                if (_.isNull(that.nextPaginationUrl) || that.nextPaginationUrl === '') {
                    $state.loaded();
                    $state.complete();
                    return;
                }

                axios.get(that.nextPaginationUrl)
                    .then(response => {
                        that.items = that.items.concat(response.data.data);
                        if (_.isNull(response.data.meta.pagination._links.next)) {
                            $state.complete();
                        } else {
                            that.nextPaginationUrl = response.data.meta.pagination['_links']['next'];
                            $state.loaded();
                        }
                    });
            }, 500)
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('list-view-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';
</style>
